import classNames from 'classnames';
import React from 'react';

export type FormErrorTextProps = {
    message: React.ReactNode;
    className?: string;
};

export function FormErrorText({ message, className }: FormErrorTextProps) {
    return (
        <div className={classNames('form-error-text', className)}>
            {message}
        </div>
    );
}
